import { Box, BoxProps, ButtonProps, IconButton, LoaderNew, ModBox, Spacer, Text, TextProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../components/Container'
import { NewTable } from '../../components/NewTable'
import { useLazyApiData, useStores } from '../../data/store'
import { ModalDialogContainer } from './ModalDialogContainer'
import { Pagination } from './Pagination'

interface HoldTransactionsModalProps {
  show: boolean
  onDismiss: any
  merchantDetail: any
  type: string
}

export const HoldTransactionsModal = ({ show, onDismiss, merchantDetail, type }: HoldTransactionsModalProps) => {
  const {
    transactions,
    uploadRiskTnxsEvidenceAync,
    downloadRiskTnxsEvidenceAsync,
    onTransactionListCheckChanged,
    hasTransactionChecked,
    searchRiskTxns,
    processTnxsAsync,
    accessConfig,
    onTransactionListAllCheckChanged,
  } = useStores((store) => ({
    transactions: store.riskConfig.getTransactionList(),
    uploadRiskTnxsEvidenceAync: store.riskConfig.uploadRiskTnxsEvidenceAync,
    downloadRiskTnxsEvidenceAsync: store.riskConfig.downloadRiskTnxsEvidenceAsync,
    onTransactionListCheckChanged: store.riskConfig.onTransactionListCheckChanged,
    hasTransactionChecked: store.riskConfig.getHasTransactionChecked(),
    searchRiskTxns: store.riskConfig.searchRiskTxns,
    processTnxsAsync: store.riskConfig.processTnxsAsync,
    accessConfig: store.user.accessConfig,
    onTransactionListAllCheckChanged: store.riskConfig.onTransactionListAllCheckChanged,
  }))
  const { width }: any = useWindowDimensions()
  const abortControllerRef = useRef<AbortController>()

  const [lazySearchTxns, searchTxnsHandler] = useLazyApiData(searchRiskTxns)
  const [lazyUploadRiskTnxsEvidence, uploadRiskTnxsEvidenceHandler] = useLazyApiData(uploadRiskTnxsEvidenceAync)
  const [lazyDownloadRiskTnxsEvidence, downloadRiskTnxsEvidenceHandler] = useLazyApiData(downloadRiskTnxsEvidenceAsync)
  const [lazyProcessTnxsAsync, processTnxsHandler] = useLazyApiData(processTnxsAsync)

  const [paginationInfo, setPaginationInfo] = useState({
    dataWindow: 10,
    pageNumber: 1,
    total: 0,
  })

  console.log(' htag merchantDetail', merchantDetail)
  const [comments, setComments] = useState('')

  const hasRiskupdatePermission = JSON.parse(accessConfig)?.ess?.risk_config?.update?.isAccessible

  /* const  = useCallback(() => {
    //return JSON.parse(accessConfig)?.ess?.risk_config?.update?.isAccessible

    return false
  }, [accessConfig])*/

  const fetchTransactions = useCallback(
    (pageNo, datawindow) => {
      abortControllerRef?.current?.abort()
      abortControllerRef.current = new AbortController()
      lazySearchTxns(type, merchantDetail?.merchantId, merchantDetail?.created, pageNo, datawindow)
    },
    [lazySearchTxns, merchantDetail?.merchantId, type],
  )

  useEffect(() => {
    if (processTnxsHandler.state === 'fulfilled') {
      onDismiss()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processTnxsHandler.state])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchTransactions(1, 10), [])

  useEffect(() => {
    if (searchTxnsHandler.state === 'fulfilled') {
      console.log('searchTxnsHandler?.data?.page', searchTxnsHandler?.data?.page)
      setPaginationInfo({
        ...paginationInfo,
        pageNumber: searchTxnsHandler?.data?.page?.number,
        total: searchTxnsHandler?.data?.page?.totalElements,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTxnsHandler.state])

  const inputBoxConfig = () => ({
    element: document.createElement('input'),
    type: 'file',
  })

  const onCommentTextChange = useCallback((text) => {
    setComments(text)
  }, [])

  const onFileSelected = (e: any) => {
    const target = e.target as HTMLInputElement
    const fileChosen = (target.files as FileList)[0]
    console.log(fileChosen)
    lazyUploadRiskTnxsEvidence(fileChosen, merchantDetail.merchantId)
  }

  const onSelectFilePress = (): void => {
    const inputBoxConfigTemp = inputBoxConfig()
    const inputBox = inputBoxConfigTemp.element
    inputBox.type = inputBoxConfigTemp.type
    inputBox.accept = '.pdf,.zip,.png,.jpg,jpeg,.txt,.xls'
    inputBox.draggable = true
    inputBox.click()
    inputBox.onchange = onFileSelected
  }

  const onCheckChangeListner = useCallback(
    (isChecked, index, row) => {
      onTransactionListCheckChanged(row, isChecked)
    },
    [onTransactionListCheckChanged],
  )
  const onPageClick = useCallback(
    (pageNumber: number) => {
      console.log('onPageClick pageNumber =', pageNumber)
      setPaginationInfo({ ...paginationInfo, pageNumber })
      fetchTransactions(pageNumber, paginationInfo.dataWindow)
    },
    [fetchTransactions, paginationInfo],
  )

  const onItemsCountSelect = useCallback(
    (count: string) => {
      console.log('onItemsCountSelect count =', count)

      setPaginationInfo({ ...paginationInfo, pageNumber: 1, dataWindow: parseInt(count, 10) })
      fetchTransactions(1, count)
    },
    [fetchTransactions, paginationInfo],
  )

  const downloadEvidence = useCallback(() => {
    const docId = uploadRiskTnxsEvidenceHandler?.data?.docId
    console.log('htag uploadRiskTnxsEvidenceHandler', uploadRiskTnxsEvidenceHandler)
    const entityId = merchantDetail.merchantId
    lazyDownloadRiskTnxsEvidence(entityId, docId)
  }, [lazyDownloadRiskTnxsEvidence, merchantDetail.merchantId, uploadRiskTnxsEvidenceHandler?.state])

  const onToggleAllSelected = useCallback((isChecked) => {
    console.log('isChecked', isChecked)
    onTransactionListAllCheckChanged(isChecked)
  }, [])

  return (
    <ModalDialogContainer show={show} onDismiss={onDismiss} merchantId={merchantDetail.merchantId}>
      <Container
        isLoading={searchTxnsHandler.state === 'pending'}
        errorMessage={searchTxnsHandler?.data?.message as any}
        onRetry={fetchTransactions}
        nativeID="vertical-scroll"
        minHeight={150}
        flex={1}>
        <NewTable
          data={transactions}
          rowHeight={32}
          headerHeight={38}
          tableWidth={width * 0.9 - 20}
          customWidthFunc={getCustomColumnWidth}
          headerRowKeys={transactionsHeaders(type)}
          onRowClick={undefined}
          showHeaderCheckBox={true}
          getIsAllSelected={onToggleAllSelected}
          onCheckChange={onCheckChangeListner}
          enableCheckBox={hasRiskupdatePermission}
        />
      </Container>
      <Pagination
        dataWindow={paginationInfo.dataWindow}
        onPageClick={onPageClick}
        onItemsCountSelect={onItemsCountSelect}
        pageNumber={paginationInfo.pageNumber}
        totalPages={Math.ceil(paginationInfo.total / paginationInfo.dataWindow)}
        total={paginationInfo.total}
      />
      <ModBox show={hasRiskupdatePermission}>
        <Box {...styles.footerContainer}>
          <Box flexDirection={'column'} flex={0.7} pr={48}>
            <Text {...styles.heading}> Upload Evidence </Text>
            <Spacer size={4} direction="vertical" />
            <Text {...styles.subHeading}> ** Only PDF, JPG, PNG, JPEG, TXT, XLS and ZIP are accepted. </Text>
            <Spacer size={8} direction="vertical" />
            <ButtonNew
              onPress={onSelectFilePress}
              isLoading={uploadRiskTnxsEvidenceHandler.state === 'pending'}
              disabled={!hasTransactionChecked}
              {...styles.uploadButton}
            />
            <Spacer size={8} direction="vertical" />
            <ModBox
              flexDirection={'row'}
              alignItems={'center'}
              show={uploadRiskTnxsEvidenceHandler.state === 'fulfilled'}>
              <Text {...styles.success}> ** Document uploaded sucessfully.</Text>

              <Box width={30} height={30}>
                {downloadRiskTnxsEvidenceHandler.state === 'pending' && <LoaderNew type={'small'} color="PRIMARY" />}
                {downloadRiskTnxsEvidenceHandler.state !== 'pending' && (
                  <IconButton id={'EYE_WATCH'} onPress={downloadEvidence} size={24} color="PRIMARY" />
                )}
              </Box>
            </ModBox>
          </Box>
          <Box flex={1}>
            <Box marginLeft={4} paddingBottom={16}>
              <Text {...styles.subHeading}>
                Add comments
                <Text {...styles.subHeading} color={'MATERIAL_PRIMARY_COLOR_RED'}>
                  {' (** Mandatory)'}
                </Text>
              </Text>
            </Box>
            <TextInputNew
              multiline={true}
              minHeight={60}
              showBottomLine={false}
              value={comments}
              onChangeText={onCommentTextChange}
              borderColor={'PRIMARY'}
              paddingHorizontal={16}
              paddingVertical={8}
              fontSize={12}
              labelFontFamily="jioType-light"
              placeholder="Add comments..."
              placeholderTextColor={'GRAY_LIGHT'}
              focusBorderColor={'PRIMARY'}
            />
          </Box>
        </Box>
        <Box pv={16} justifyContent={'center'} alignItems={'center'}>
          <ButtonNew
            onPress={() =>
              lazyProcessTnxsAsync(
                uploadRiskTnxsEvidenceHandler?.data?.docId,
                comments,
                type,
                merchantDetail?.merchantId,
                merchantDetail?.businessName,
              )
            }
            type={'primaryIconSmall'}
            title={'Submit'}
            icon="TICKMARK"
            width={300}
            isLoading={processTnxsHandler.state === 'pending'}
            disabled={!hasTransactionChecked || comments?.trim().length === 0}
          />
        </Box>
      </ModBox>
    </ModalDialogContainer>
  )
}

export const transactionsHeaders = (type: string) => ({
  check: '',
  transDateTime: 'Transaction Date',
  created: type === 'PAYOUT_STAGED' ? 'Created At' : 'Held At',
  originalTransactionId: 'Transaction Id',
  settlementGrossAmount: 'Amount',
  status: 'Status',
})
export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    check: 30,
    transDateTime: 80,
    originalTransactionId: 80,
    settlementGrossAmount: 80,
    status: 80,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const styles = {
  container: {
    backgroundColor: 'WHITE',
    width: '60vw',
    height: '80vh',
    borderRadius: 8,
    overflow: 'auto',
  } as BoxProps,
  header: {
    ph: 16,
    pv: 8,
    backgroundColor: 'PRIMARY',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as BoxProps,
  headerTitle: {
    fontSize: 16,
    fontFamily: 'jioType-bold',
    color: 'WHITE',
  } as TextProps,
  subHeaderTitle: {
    fontSize: 18,
    fontFamily: 'jioType-bold',
    color: 'BLACK_21',
  } as TextProps,
  subHeadingConatainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    padding: 16,
  } as BoxProps,
  heading: {
    color: 'BLACK_21',
    fontFamily: 'jioType-bold',
    fontSize: 16,
  } as TextProps,
  subHeading: {
    color: 'BLACK_75',
    fontFamily: 'jioType-medium',
    fontSize: 12,
  } as TextProps,
  success: {
    color: 'HAZY_GREEN',
    fontFamily: 'jioType-bold',
    fontSize: 12,
  } as TextProps,
  footerContainer: {
    flexDirection: 'row',
    ph: 32,
    pv: 16,
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderColor: 'BORDER_COLOR',
  } as BoxProps,
  uploadButton: {
    type: 'secondaryIcon',
    icon: 'UPLOAD',
    borderColor: 'PRIMARY',
    title: 'Upload Document',
    height: 32,
  } as ButtonProps,
}
